import { UtilService } from '@app/shared/services/util.service';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError, pipe } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { GenericService } from '@app/core/services/generic.service';

import { ConfigCamposFormulario, Loading } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class ValidarRequiredFormService extends GenericService<any> {

  form: FormGroup;
  configuracoes: ConfigCamposFormulario;

  constructor(
    http: HttpClient,
    private utilService: UtilService
    ) {
    super('censo', http);
  };

  buscarConfiguracoesForm(id: number, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().get<ConfigCamposFormulario[]>(`${this.api}/${id}/formulario`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  definirValidatorRequiredNosCampos(form: FormGroup, configuracoes: ConfigCamposFormulario[]): FormGroup {
    if (!configuracoes || !form) return form;

    configuracoes.forEach(configuracao => {
      const campoForm = form.get(configuracao.nomeCampo);

      if (campoForm) {
        this.utilService.definirValidatorRequired(campoForm, configuracao.obrigatorio);
      }

      if (campoForm && !configuracao.visivel) {
        campoForm.disable();
      }
    });

    return form;
  }

  result(): any {
    return pipe(
      map((res: any) => res),
      catchError((err: any) => throwError({ message: err })));
  }
}
